import interactionHighlight from './interactionHighlight';

export default {
  styleOverrides: {
    '@media (hover: none) and (pointer: coarse)': {
      html: {
        WebkitTapHighlightColor: 'transparent',
      },
    },
    '*::selection': {
      backgroundColor: interactionHighlight,
    },
  },
};
